package com.taager.dukan.feature.productlist

sealed class ProductListSideEffect {
    data class GoToProductDetails(val sku: String) : ProductListSideEffect()
}
